module.exports = __webpack_public_path__ + "static/img/gnmk_4@2x.ddcfd38c.png";